<template>
  <footer class="site-footer"><div class="container"><router-link to="/" class="footer-wordmark">the NAKAMOTOS.club</router-link><p>CryptoArt on Bitcoin · 2016—2026</p><router-link :to="{ path: '/', hash: '#provenance' }">Every card is unique ↗</router-link></div></footer>
</template>
<style scoped>
.site-footer { background: #183f19; padding: 23px 0; color: #b3c8a7; }
.site-footer .container { display: flex; justify-content: space-between; gap: 20px; align-items: center; }
a { color: #dceaca; font-size: 11px; }
.footer-wordmark { font: 11px var(--font-titles); }
p { font-size: 12px; }
@media (max-width: 700px) { .site-footer .container { align-items: start; flex-direction: column; gap: 12px; } }
</style>
